export default __webpack_public_path__ + "static/media/Shadow's Bracers of the Smoldering Throne.3d61c936.jpg";